module.exports = __webpack_public_path__ + "img/智能密集架.24d3af81.jpg";